import { CampaignSchedule } from '@/pages/Novi/types/Schedule';
import apiClient from '@/utils/apiClient';

const CREATE_SCHEDULE = '/api/novi/schedule';
const GET_SCHEDULE = '/api/novi/schedules/:campaign_id';
const GET_SCHEDULE_STATUS = '/api/novi/schedule/status';
const UPDATE_SCHEDULE = '/api/novi/schedule/:campaign_id';

const CREATE_TEXT_SCHEDULE = '/api/novi/text-schedule';
const GET_TEXT_SCHEDULE = '/api/novi/text-schedules/:campaign_id';
const UPDATE_TEXT_SCHEDULE = '/api/novi/text-schedule/:campaign_id';

const NOVI = 'NOVI';

export const createSchedule = async (payload: {
	campaign_id: string;
	clientType: 'Reseller' | 'Client';
	schedule: {
		allowed_retries: number;
		time_between_retries: number;
		allowed_times_start: string;
		allowed_times_end: string;
		days: number[];
		timezone: string;
	};
}): Promise<{ message: string }> => {
	const { clientType, ...body } = payload;
	const response = await apiClient.request({
		method: 'POST',
		clientType: clientType === 'Reseller' ? 'RESELLER' : 'RECEPTIONIST',
		endPoint: CREATE_SCHEDULE,
		body,
	});

	return response;
};

export const getSchedule = async (
	campaign_id: string,
): Promise<{ schedule: CampaignSchedule | null }> => {
	const response = await apiClient.request({
		method: 'GET',
		clientType: NOVI,
		endPoint: GET_SCHEDULE.replace(':campaign_id', campaign_id),
	});

	return response;
};

export const updateScheduleStatus = async (payload: {
	campaign_id: string;
	status: string;
}): Promise<{ message: string }> => {
	const response = await apiClient.request({
		method: 'PATCH',
		clientType: NOVI,
		endPoint: GET_SCHEDULE.replace(':campaign_id', payload.campaign_id),
		body: { status: payload.status },
	});

	return response;
};

export const updateSchedule = async (
	campaign_id: string,
	scheduleData: {
		allowed_retries?: string | number;
		time_between_retries?: string | number;
		allowed_times_start?: string;
		allowed_times_end?: string;
		days?: number[];
		timezone?: string;
		status?: string;
	},
): Promise<{ message: string; schedule: CampaignSchedule }> => {
	const response = await apiClient.request({
		method: 'PUT',
		clientType: NOVI,
		endPoint: UPDATE_SCHEDULE.replace(':campaign_id', campaign_id),
		body: scheduleData,
	});

	return response;
};

export const getScheduleStatus = async (campaign_id: string): Promise<{ status: string }> => {
	const response = await apiClient.request({
		method: 'GET',
		clientType: NOVI,
		endPoint: `${GET_SCHEDULE_STATUS}?campaign_id=${campaign_id}`,
	});

	return response;
};

export const createTextSchedule = async (payload: {
	campaign_id: string;
	schedule: {
		daily_limit: number;
		allowed_times_start: string;
		allowed_times_end: string;
		days: number[];
		timezone: string;
	};
}): Promise<{ message: string }> => {
	const response = await apiClient.request({
		method: 'POST',
		clientType: NOVI,
		endPoint: CREATE_TEXT_SCHEDULE,
		body: payload,
	});

	return response;
};

export const getTextSchedule = async (
	campaign_id: string,
): Promise<{ schedule: CampaignSchedule | null }> => {
	const response = await apiClient.request({
		method: 'GET',
		clientType: NOVI,
		endPoint: GET_TEXT_SCHEDULE.replace(':campaign_id', campaign_id),
	});

	return response;
};

export const updateTextSchedule = async (
	campaign_id: string,
	scheduleData: {
		daily_limit: number;
		allowed_times_start: string;
		allowed_times_end: string;
		days: number[];
		timezone: string;
	},
): Promise<{ message: string; schedule: CampaignSchedule }> => {
	const response = await apiClient.request({
		method: 'PUT',
		clientType: NOVI,
		endPoint: UPDATE_TEXT_SCHEDULE.replace(':campaign_id', campaign_id),
		body: scheduleData,
	});

	return response;
};
